import { Platform } from '@ionic/angular';

export const getScreenHeightWithoutTopBar = (
  platform: Platform,
): {
  height: number;
  width: number;
} => {
  let height = platform.height() ?? 0;

  const layoutContentWrapper = document.querySelector('.layout-content-wrapper');
  let wrapperPadding = 0;
  if (layoutContentWrapper) {
    const wrapperComputedStyles = window.getComputedStyle(layoutContentWrapper, null);
    wrapperPadding = +(wrapperComputedStyles.paddingTop ?? '0').replace('px', '');
    height -= wrapperPadding - 2;
  }

  const layoutContent = document.querySelector('.layout-content');
  if (layoutContent) {
    const contentComputedStyles = window.getComputedStyle(layoutContent, null);

    height = +(contentComputedStyles.height ?? '0').replace('px', '');

    height -= +(contentComputedStyles.paddingTop ?? '0').replace('px', '');
    if (!platform.isPortrait()) {
      height -= +(contentComputedStyles.paddingBottom ?? '0').replace('px', '');
    }
  }

  height -= 10;
  const width = platform.width();

  return {
    height,
    width,
  };
};
